import { render, staticRenderFns } from "./MoreHistorySpread.vue?vue&type=template&id=bf98c774&scoped=true"
import script from "./MoreHistorySpread.vue?vue&type=script&lang=js"
export * from "./MoreHistorySpread.vue?vue&type=script&lang=js"
import style0 from "./MoreHistorySpread.vue?vue&type=style&index=0&id=bf98c774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf98c774",
  null
  
)

export default component.exports